<template>
  <div id="app">
    <!-- START NAVBAR -->
    <Navbar v-show="!['customerNotice'].includes($route.name)"  />
   


    <div >
      <router-view />
    </div>

    <Footer v-show="!['customerNotice'].includes($route.name)" />
  </div>
</template>

<script>
import Navbar from '@/components/tabbar/navbar.vue';
import Footer from '@/components/tabbar/footer.vue';
export default {
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
   
    };
  },
  created() {
    
  },
  mounted() {
   
      
  },
  methods: {


  },
  watch: {
  
  }
};
</script>

